module.exports = __webpack_public_path__ + "img/discounts.f525f7b1.svg";